import { render } from "./CustomerDetails.vue?vue&type=template&id=f66f4adc"
import script from "./CustomerDetails.vue?vue&type=script&lang=js"
export * from "./CustomerDetails.vue?vue&type=script&lang=js"
script.render = render

export default script